import React from "react";
import ConnectionFormDialog from "../../../components/forms/ConnectionFormDialog";
import FormSelectField from "../../../components/forms/fields/basic/SelectField";
import FormEntitySelectionField from "../../../components/forms/fields/basic/EntitySelectionField";
import AccordionSubFormContainer from "../../../components/forms/fields/subForms/accordion/AccordionSubFormContainer";
import AccordionSubForm from "../../../components/forms/fields/subForms/accordion/AccordionSubForm";
import renderPersonSelection from "../../../components/entitiesReferences/SelectionModals/PersonSelectionModal";
import renderPlaceSelection from "../../../components/entitiesReferences/SelectionModals/PlaceSelectionModal";
import renderVersionSelection from "../../../components/entitiesReferences/SelectionModals/VersionSelectionModal";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import { Version } from "../../../types/version";
import { Person } from "../../../types/person";
import { Place } from "../../../types/place";
import { ConnectionFormDataController } from "../../../controllers/formController";
import {
  ContributorConnection,
  SystemContributorTypes,
} from "../../../types/contributor";
import NameInternalEvidence from "../../forms/common/subForms/NameInternalEvidence";
import NameExternalEvidence from "../../forms/common/subForms/NameExternalEvidence";
import useContributorLogic from "../../../hooks/logic/connections/contributorLogic";

interface ContributorDialogProps {
  controller: ConnectionFormDataController<ContributorConnection, Version, Person>;
  contributorType: SystemContributorTypes;
  systemLanguageType: ContributorConnection["system_language_type"];
}

const ContributorDialog: React.FC<ContributorDialogProps> = ({
  controller,
  contributorType,
  systemLanguageType,
}) => {
  const contributorLogic = useContributorLogic(
    controller.from,
    controller.to,
    contributorType,
    systemLanguageType
  );

  return (
    <ConnectionFormDialog<ContributorConnection, Version, Person>
      controller={controller}
      fromLabel="Version"
      fromEntityCollection={SystemEntityCollections.VERSION}
      toLabel="Person"
      toEntityCollection={SystemEntityCollections.PERSON}
      renderFromEntitySelection={renderVersionSelection(systemLanguageType)}
      renderToEntitySelection={renderPersonSelection}
    >
      {/* Status */}
      {contributorLogic.showField("status") && (
        <FormSelectField
          name="status"
          label="Status"
          placeholder="Select status"
          useEnum="contributor_status"
        />
      )}

      {/* Role */}
      {contributorLogic.showField("role") && contributorLogic.roleEnum && (
        <FormSelectField
          name="role"
          label="Role"
          placeholder="Select role"
          useEnum={contributorLogic.roleEnum}
        />
      )}

      <FormSelectField
        name="place_identification_status"
        label="Place Identification"
        placeholder="Select identification status"
        useEnum="contributor_place_identification_status"
      />

      <FormEntitySelectionField<Place>
        name="place"
        label="Place"
        placeholder="Select place"
        entityCollection={SystemEntityCollections.PLACE}
        renderEntitySelection={renderPlaceSelection}
      />

      <AccordionSubFormContainer>
        <AccordionSubForm
          name="name_internal_evidence"
          label="Name Internal Evidence"
        >
          <NameInternalEvidence />
        </AccordionSubForm>
        <AccordionSubForm
          name="name_external_evidence"
          label="Name External Evidence"
        >
          <NameExternalEvidence />
        </AccordionSubForm>
      </AccordionSubFormContainer>
    </ConnectionFormDialog>
  );
};

export default ContributorDialog;
